import Vue from 'vue'
import store from '@/store'
import gainsightDir from './gainsightDirectives'

// Aptrinsic script 
  (function(n, t, a, e, co) {
    let i = "aptrinsic";
    (n[i] =
      n[i] ||
      function() {
        (n[i].q = n[i].q || []).push(arguments);
      }),
      (n[i].p = e);
    n[i].c = co;
    let r = t.createElement("script");
    (r.async = !0), (r.src = a + "?a=" + e);
    let c = t.getElementsByTagName("script")[0];
    c.parentNode.insertBefore(r, c);
    })(window, document, "https://web-sdk.aptrinsic.com/api/aptrinsic.js", "AP-HQ8F6KENF3NB-2",{"fullDomainCookie": true});
// End Aptrinsic script

//add v-track directive into vue
  Vue.directive('track', gainsightDir);


export function setAptrinsic () {
  const userdata = store.getters['auth/userdata']
  const account = store.getters['auth/account']
  const industryName = store.getters['auth/userIndustry'] ? store.getters['auth/userIndustry'] : "UNKNOWN"
  const defaultAccount = store.getters['auth/defaultAccount'] ? store.getters['auth/defaultAccount'] : "UNKNOWN"
  if (typeof aptrinsic === 'function') {
    aptrinsic(
      'identify',
      {
        id: userdata.email,
        email: userdata.email,
        firstName: userdata.first_name,
        lastName: userdata.last_name,
        signUpDate: new Date(userdata.created_at).getTime(),
        defaultAccount: defaultAccount
      },
      {
        id: account.id,
        name: account.name,
        industry: industryName
      },
    )
  }
}